import { Component } from "@angular/core";


@Component({
    selector: 'ui-data-cell',
    templateUrl: './ui-data-cell.component.html'
})
export class UIDataCellComponent {

}
